import React, { memo } from 'react';
import { string, oneOfType, number } from 'prop-types';

import { priceToDisplay } from 'utils/price';
import Image from 'components/Image';

const FundraiserPreview = ({ image, name, city, raised, goal }) => {
  return (
    <div className="relative mx-auto lg:w-72 xl:w-96 h-72 p-7 rounded-xl shadow-2xl bg-white border-transparent box-border flex flex-col justify-between">
      <div>
        <div className="w-16 h-16 overflow-hidden rounded-md">
          <Image src={image} alt={name} />
        </div>
        <div className="mt-4">
          <h1
            className={`block h-7 overflow-hidden text-javelin-gray-dark text-lg font-bold tracking-wide ${
              !name ? 'bg-gray-100 w-60 rounded transition duration-300' : ''
            }`}
            data-testid="name"
          >
            {name}
          </h1>
          <p
            className={`block mt-2 h-4 text-gray-400 text-sm ${
              !city ? 'bg-gray-100 w-24 rounded' : ''
            }`}
            data-testid="city"
          >
            {city}
          </p>
        </div>
      </div>
      <div>
        <span
          data-testid="raised-amount"
          className="text-base font-semibold text-javelin-gray-dark mt-10 inline-block"
        >
          {`€${priceToDisplay(raised)} raised `}
          <span className="text-base text-gray-400">
            {`of €${priceToDisplay(goal)} goal`}
          </span>
        </span>
        <hr className="horizontal-line border-t-6 opacity-50" />
      </div>
    </div>
  );
};

FundraiserPreview.propTypes = {
  image: string,
  name: string,
  raised: oneOfType([string, number]),
  goal: oneOfType([string, number]),
};
FundraiserPreview.defaultProps = {
  image: '',
  name: '',
  raised: 0,
  goal: 0,
};

export default memo(FundraiserPreview);
